import type { FirebaseServices } from './app.ts';

export type ShopRecords = {
  shop: Record<string, unknown> | null;
  legacyProfile: Record<string, unknown> | null;
};

// Public reads only: the v2 shop record and the legacy seller profile.
// Private shop data is never read from the browser; the Worker serves it.
export async function readShopRecords(services: FirebaseServices, shopId: string): Promise<ShopRecords> {
  const [{ doc, getDoc }, { get, ref }, firestore, database] = await Promise.all([
    import('firebase/firestore'), import('firebase/database'), services.firestore(), services.database(),
  ]);
  const [shopSnapshot, profileSnapshot] = await Promise.all([
    getDoc(doc(firestore, 'shops', shopId)),
    get(ref(database, `public_profiles/${shopId}`)),
  ]);
  return {
    shop: shopSnapshot.exists() ? shopSnapshot.data() : null,
    legacyProfile: profileSnapshot.exists() ? (profileSnapshot.val() as Record<string, unknown>) : null,
  };
}

export async function readDocument(services: FirebaseServices, collection: string, id: string): Promise<Record<string, unknown> | null> {
  const [{ doc, getDoc }, firestore] = await Promise.all([import('firebase/firestore'), services.firestore()]);
  const snapshot = await getDoc(doc(firestore, collection, id));
  return snapshot.exists() ? snapshot.data() : null;
}
